import nunjucks from 'nunjucks';

/**
 * @param {string} filePath
 * @param {object} parameters
 * @returns {Promise<string>}
 */
function render(filePath, parameters = {}) {
	return new Promise((resolve, reject) => {
		const environment = nunjucks.configure({ autoescape: false });
		environment.render(filePath, parameters, (error, content) => {
			/* istanbul ignore if */
			if (error) {
				reject(error);
				return;
			}
			resolve(content);
		});
	});
}

export { render };
